import {
  DatabaseTraceAction,
  DatabaseTraceSource,
  traceDatabaseAction,
} from '@databases/frontend-metrics/perf-tracing';
import { doClearValues } from '@databases/redux/contextual-menu/actions';
import { appStore } from '@databases/redux/store';

/**
 * This shared util is used by the context menu item to trigger the clearing
 * of values associated with the specified `contentId`.
 */
export function clearValues(contentId: string): void {
  traceDatabaseAction(
    { action: DatabaseTraceAction.ValueClear, source: DatabaseTraceSource.ValueMenu },
    () => {
      appStore.dispatch(doClearValues(contentId));
    }
  );
}
